import { Injectable } from '@angular/core';
import { User } from '@mitel/cloudlink-sdk';
import { PolicyTestRequest } from '@mitel/cloudlink-sdk/authentication';
import { mivoice5000Licenses, PolicyEffects } from '../constants/constants';
import { AdminService } from './admin.service';
import { AuthService } from './auth.service';
import { OrdersService } from './orders.service';

// there are 4!! resources to test for to determine if the usesr has a license
const mivoice5000LicenseResource = [
  {
    resource: "https://mitel.io/auth/meet/licenses/login", 
    action: "*"
  },
  {
    resource: "https://mitel.io/auth/media/licenses/conferences", 
    action: "POST"
  },
  {
    resource: "https://mitel.io/auth/meet/licenses/meet/recording", 
    action: "*"
  },
  {
    resource: "https://mitel.io/auth/meet/licenses/file-storage", 
    action: "*"
  }
];

@Injectable({
  providedIn: 'root'
})
export class UserMitel5000SharedService {

  constructor(
    private authSvc: AuthService,
    private adminService: AdminService,
    private ordersService: OrdersService) { 
  }


  isMitel5000LicenseAssignedToUser(user: User): Promise<boolean> {
    const feature:PolicyTestRequest = {
      principalId: user.userId,
      resources: [...mivoice5000LicenseResource]
    };
    return this.authSvc.testPolicy(feature).then( r => {
      console.log("This is the policy reply", r);
      let resp = r;
      if ( resp && resp.results )
      {
        const mitel5000Response0 = resp.results.find(res => {
            return res.resource === mivoice5000LicenseResource[0].resource;
        });
        console.log("mitel5000Response0", mitel5000Response0);
        const mitel5000Response1 = resp.results.find(res => {
          return res.resource === mivoice5000LicenseResource[1].resource;
        });
        console.log("mitel5000Response1", mitel5000Response1);
        const mitel5000Response2 = resp.results.find(res => {
          return res.resource === mivoice5000LicenseResource[2].resource;
        });
        console.log("mitel5000Response2", mitel5000Response2);
        const mitel5000Response3 = resp.results.find(res => {
          return res.resource === mivoice5000LicenseResource[3].resource;
        });
        console.log("mitel5000Response3", mitel5000Response3);
        
        if ( mitel5000Response0 && mitel5000Response1 && mitel5000Response2 && mitel5000Response3 && 
          (PolicyEffects[mitel5000Response0.effect] === PolicyEffects.ExplicitAllow) &&
          (PolicyEffects[mitel5000Response1.effect] === PolicyEffects.ExplicitAllow) &&
          (PolicyEffects[mitel5000Response2.effect] === PolicyEffects.ExplicitAllow) &&
          (PolicyEffects[mitel5000Response3.effect] === PolicyEffects.ExplicitAllow) ) 
        {
            return true;
        }
        return false;

      }
      return false;
    });
  }

  postLicenseChangeProcessing(user: User, alreadyHadLicense: boolean ): Promise<any> {
    return new Promise(async (resolve, reject) => {
        if ( alreadyHadLicense ) 
        {
          // No need to send the welcome email on change of Mitel 5000 tier.
          resolve(true);
        } 
        else 
        {
          try 
          {

            if ( user.userVerified != true ) 
            {
              console.log("User is not verified, so we will send a welcome email for the new license for miteam meetings", user.userId);
              // send an email if user is not verified
              let emailBody = { "application": 'meetings' };
              await this.adminService.sendWelcomeEmailWithoutNotify(user.accountId, user.userId, emailBody);
  
            } 
            else 
            {
              // user was verified
              await this.adminService.sendMiteamMeetingOnlyWelcomeEmail(user);
            }
  
          } 
          catch (err) 
          {
            console.error("Failed to send the welcome email for the the Miteam meetings license", err);
          }
          resolve(true);
        }
		});
  }

  getRemainingLicenseDetails() {
 
    return this.ordersService.getRemainingLicenses(true).then( remainingLicenses => {
      let licenseInfo = {};
        for( let license in remainingLicenses) {
           if (mivoice5000Licenses.includes(license)) {
            licenseInfo[license] = remainingLicenses[license];
          }
        }
        return licenseInfo;
      })
      .catch(error => {
        console.log("There was a problem fetching license information", error);
        return {};
      });
  }


}
